import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'libero-profile-fees-confirm-modal',
  templateUrl: './profile-fees-confirm-modal.component.html',
  styleUrl: './profile-fees-confirm-modal.component.scss',
  standalone: false,
})
export class ProfileFeesConfirmModalComponent {
  @Input() public show: boolean | null = null;
  @Output() public continueBtnClick = new EventEmitter<void>();
  @Output() public backBtnClick = new EventEmitter<void>();

  public onContinueBtnClick(): void {
    this.continueBtnClick.emit();
  }

  public onBackBtnClick(): void {
    this.backBtnClick.emit();
  }
}
